import React from 'react';
import classes from './DropdownMenu.module.css';
import arrowDD from '../../../assets/icons/arrow-dd.svg';
import { useTranslation } from '../../../hooks/useTranslations';

type Item = {
  label: string;
  icon?: string;
  value: number;
};

type Props = {
  items: Item[];
  selectedItemValue?: number;
  onSelectItem?: (val: number) => void;
};

const DropdownMenu: React.FC<Props> = ({ items, selectedItemValue = 0, onSelectItem }) => {
  const { translations } = useTranslation();
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const selectedItem = items.find((item) => item.value === selectedItemValue);

  return (
    <div className={classes.menuHeader}>
      {selectedItem?.icon && (
        <img src={selectedItem.icon} alt={'icon'} className={classes.titleIcon} />
      )}
      <div className={classes.menuHeaderTitle} onClick={() => setIsOpen(!isOpen)}>
        <div>{translations(selectedItem?.label ?? '')}</div>
        <img className={classes.arrow} src={arrowDD} alt={'arrow dd'} />
      </div>
      <div className={classes.dropDownMenuContainer}>
        {isOpen && <div className={classes.backdrop} onClick={() => setIsOpen(false)} />}
        <div className={`${classes.dropDownMenu} ${isOpen ? '' : classes.hideDropDownMenu}`}>
          {items.map((menuItem) => (
            <div
              key={menuItem.label}
              className={classes.dropDownMenuItem}
              onClick={() => {
                onSelectItem && onSelectItem(menuItem.value);
                setIsOpen(false);
              }}
            >
              {translations(menuItem.label)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { DropdownMenu };
